import React from "react"

export class Loader extends React.Component{
    render = () => <span className="loader"></span>
}